import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImgInboxEmpty = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 56,
		height: 56,
		rx: 28,
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.0938 20.2656L17.6406 30.25H22.375C22.8438 30.25 23.3125 30.4844 23.5938 30.9062L24.6719 32.5H31.375L32.4062 30.9062C32.6875 30.4844 33.1562 30.25 33.6719 30.25H38.4062L36.9062 20.2656C36.8125 19.5625 36.2031 19 35.4531 19H20.5938C19.8438 19 19.1875 19.5625 19.0938 20.2656ZM17.5 31.75V35.5C17.5 36.3438 18.1562 37 19 37H37C37.8438 37 38.5 36.3438 38.5 35.5V31.75H33.6719L32.5938 33.3438C32.3125 33.7656 31.8438 34 31.3281 34H24.6719C24.1562 34 23.6875 33.7656 23.4062 33.3438L22.3281 31.75H17.5ZM20.5938 17.5H35.4531C36.9062 17.5 38.1719 18.5781 38.4062 20.0781L39.9531 30.7188C40 30.8594 40 31 40 31.1875V35.5C40 37.1406 38.6406 38.5 37 38.5H19C17.3594 38.5 16 37.1406 16 35.5V31.1875C16 31 16 30.8594 16.0469 30.7188L17.5938 20.0781C17.8281 18.5781 19.0938 17.5 20.5938 17.5Z",
		fill: "#868686"
	})]
});
export default SvgImgInboxEmpty;
